import $ from 'jquery';

const wishlistPageV1Semantics = {
    'containerSelector': '.wishlist-page-v1',
    //deps
    'dependWishListSelector': '.add-to-wishlist-v1',
    'dependParentRemoveSelector': '.product-card-v2',
};

$(function () {
    let wishlistPageV1 = new WishlistPageV1();
    wishlistPageV1.subscribe();
});

class WishlistPageV1 {
    subscribe() {
        let self = this;
        $(document).on(
            'click',
            wishlistPageV1Semantics.containerSelector
            + ' '
            + wishlistPageV1Semantics.dependWishListSelector,
            function (e) {
                e.preventDefault();
                let initiatorElement = $(e.currentTarget);
                initiatorElement.closest(wishlistPageV1Semantics.dependParentRemoveSelector).detach();
            }
        )
    }
}